// extracted by mini-css-extract-plugin
export default {"root":"TimeSlotsRadioGroup_root__xMfjj","option":"TimeSlotsRadioGroup_option__tIatI"};